import Field from "@/components/booking/Field";

export default function DateTimeFields({ t, form, set, errors, minDate }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <Field
        label={t.booking.fields.date}
        error={errors.preferred_date}
      >
        <input
          data-testid="booking-date-input"
          type="date"
          className={`input-field ${errors.preferred_date ? "error" : ""}`}
          value={form.preferred_date}
          min={minDate}
          onChange={(e) => set("preferred_date", e.target.value)}
        />
      </Field>
      <Field label={t.booking.fields.time}>
        <select
          data-testid="booking-time-select"
          className="input-field"
          value={form.preferred_time}
          onChange={(e) => set("preferred_time", e.target.value)}
        >
          {Object.entries(t.booking.times).map(([k, v]) => (
            <option key={k} value={k}>
              {v}
            </option>
          ))}
        </select>
      </Field>
    </div>
  );
}
